export default {"src":"/_next/static/media/chevron-left.9ef37fac.svg","height":12,"width":8,"blurWidth":0,"blurHeight":0};